webpackJsonp([89888082226891],{

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(71);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _emotion = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Map = function Map(_ref) {
	  var _ref$data = _ref.data,
	      mapsJson = _ref$data.mapsJson,
	      imageSharp = _ref$data.imageSharp,
	      site = _ref$data.site;
	  return _react2.default.createElement(
	    "div",
	    {
	      className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("max-width:1070px;margin:0 auto;")
	    },
	    _react2.default.createElement(_reactHelmet2.default, { title: site.siteMetadata.title + " | " + mapsJson.name }),
	    _react2.default.createElement(
	      "h1",
	      {
	        className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("margin-left:15px;")
	      },
	      mapsJson.name
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("display:flex;flex-direction:column;@media (min-width:720px){flex-direction:row;}")
	      },
	      _react2.default.createElement(
	        "div",
	        {
	          className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("flex:0 0 auto;display:flex;justify-content:center;align-items:flex-start;@media (min-width:720px){margin-right:1.0875rem;}")
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("background-image:url(\"", imageSharp && imageSharp.resolutions && imageSharp.resolutions.tracedSVG, "\");background-repeat:no-repeat;background-size:contain;")
	          },
	          _react2.default.createElement("img", {
	            src: "//res.cloudinary.com/rgdelato/image/fetch/f_auto/http://codexcards-assets.surge.sh/images/" + mapsJson.filename,
	            alt: mapsJson.name,
	            className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("@media (min-width:370px){width:330px;height:450px;}")
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("flex:1 1 0px;margin-top:15px;")
	        },
	        _react2.default.createElement(
	          "p",
	          null,
	          mapsJson.name,
	          " — ",
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/maps" },
	            "Map"
	          )
	        ),
	        _react2.default.createElement(
	          "blockquote",
	          null,
	          mapsJson.description
	        )
	      )
	    )
	  );
	};
	
	exports.default = Map;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-map-js-a6044d5337f89521ec0b.js